import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
  {
    description: 'Atividades Complementares (Módulo II)',
    path: '/academico/atividadecomplementarprofessor',
    name: 'atividadecomplementarprofessor',
    component: () => import('@/views/academico/diario/atividadecomplementarprofessor/Index.vue'),
    meta: {
      permissions: [
        eTipoPermissao.NOMEATIVIDADESCOMPLEMENTARESPROFESSOR_MENU_300301650,
        eTipoPermissao.NOMEATIVIDADESCOMPLEMENTARESPROFESSOR_MENU_300302150,
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Atividades Complementares (Módulo II)',
    path: '/academico/atividadecomplementarprofessor/cadastro/:id?',
    parent: 'atividadecomplementarprofessor',
    name: 'atividadecomplementarprofessor_create',
    component: () =>
      import('@/views/academico/diario/atividadecomplementarprofessor/components/InclusaoEdicao.vue'),
    meta: {
      permissions: [
        eTipoPermissao.NOMEATIVIDADESCOMPLEMENTARESPROFESSOR_MENU_300301650,
        eTipoPermissao.NOMEATIVIDADESCOMPLEMENTARESPROFESSOR_MENU_300302150,
      ],
    },
    goesToMenu: true,
  },
];
